import { gql } from '@apollo/client';

export const ADD_RECIPIENT_PARTY = gql`
  mutation addRecipientParty($input: RecipientPartyInput!) {
    addRecipientParty(input: $input) {
      code
      success
      message
    }
  }
`;

export const UPDATE_RECIPIENT_PARTY = gql`
  mutation updateRecipientParty($recipient_id: NonEmptyString!, $input: RecipientPartyInput!) {
    updateRecipientParty(recipient_id: $recipient_id, input: $input) {
      code
      success
      message
    }
  }
`;
